import styled from "styled-components";

export const AreaMessageConfirmation = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	p {
		margin: 0;
	}
`;
export const ContainerModalConfirmation = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	background: ${({ theme }) => theme.white};
	border-radius: 8px;
	padding: 1rem;

	h6 {
		font-weight: bold;
		color: #000;
		text-align: center;
	}
`;

export const AreaReason = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	padding-top: 0.4rem;

	.MuiInputBase-root {
		border: 1px solid ${({ theme }) => theme.grayDark};
		padding-top: 0px;
		padding-bottom: 0px;
		padding-left: 2px;
	}
`;
